import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://backend-dot-immersely-ai.nw.r.appspot.com/api/v1";

function getToken() {
  return localStorage.getItem("token");
}

export async function getSystemHealth() {
  const response = await axios.get(`${API_BASE_URL}/admin/system-health`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
}
